import { AvForm, AvGroup, AvInput, AvFeedback, } from 'availity-mobx-reactstrap-validation';
import Button from 'js/components/common/Button';
import React, {useEffect} from 'react';
import { useState } from 'react';
import { FormGroup } from 'reactstrap';
import { makeRequest } from 'js/services/Network';
import AppState from 'js/stores/AppState';
import AppUser from 'js/stores/AppUser';
import ErrorDisplay from 'js/components/common/ErrorDisplay';
import {pick} from "lodash";

const VerificationCodeDialog = (props) => {
    const [requestInProgress, setRequestInProgress] = useState(false);
    const [error, setError] = useState(null);

    const pageEvent = () => {
      const url = window.location.href;
      const urlParts = url.split('/');
      const alias = urlParts[urlParts.length - 2];
      console.log("alias ",alias)

      makeRequest('mseller-get-verification-status',null,{alias: alias})
        .then(response => {
          // console.log("response ",response.data)
          if (response && parseInt(response.data.data) === 1){
            window.location.href = '/store-activated';
          }
        })
        .catch(error => {
          console.log("error ",error)
        });
    }

  useEffect(() => {
    pageEvent();

  }, []);

    const onSubmit = async (event, errors, formValues) => {
        setRequestInProgress(true);

        makeRequest('mseller-verify-code', null, formValues)
            .then(response => {
                // If the request was successful, set the mseller
                setRequestInProgress(false);
                AppUser.setIsLoggingIn(true);
                AppUser.setIsRegistered(true);
                if (response.credit_card_details && Array.isArray(response.credit_card_details)) {
                    response.credit_card_details = {};
                }
                response.is_active && applySnapshot(self, response);
                window.app.csrf_token = response.csrf_token;
                AppState.setShowConfirmationCode(false);
                window.location.href = '/store-activated';
            })
            .catch(error => {
                setRequestInProgress(false);
                if (error.response && error.response.data && error.response.data.message) {
                    setError(error.response.data.message);
                } else {
                    setError('Invalid credentials');
                }
                return false;
            });

        return true;
    };

    return (
        <div className="verification-code-dialog">
            <h1>Verify your account</h1>
            {/*<p>We have just sent an email containing a 4-chars verification*/}
            {/*    code to the email address associated with this MicroSeller account.*/}
            {/*    Please input the code provided to verify your account.</p>*/}


          <p>We've just sent an email containing a verification
            code to the email address associated with this seller account.
            <span style={{fontWeight: 'bold', fontStyle: 'italic'}}> Take note, this verification code is your default password</span><br/><br/>
            Please input your phone number & the verification code to verify your account.</p>

            <AvForm onSubmit={onSubmit}>
                <AvGroup>
                    <AvInput name="phone_number" placeholder="08069012345" required />
                    <AvFeedback>Please enter your phone number</AvFeedback>
                </AvGroup>

                <AvGroup>
                    <AvInput name="code" placeholder="Verification code" required />
                    <AvFeedback>Please enter the verification code</AvFeedback>
                </AvGroup>

                <AvGroup>
                    <AvInput type="hidden" name="mseller" value={AppState.mseller} />
                </AvGroup>

                <FormGroup>
                    <Button type="submit" isLoading={requestInProgress}>
                        Verify Account
                    </Button>
                </FormGroup>

                <ErrorDisplay>{error}</ErrorDisplay>
            </AvForm>
        </div>
    );
};

export default VerificationCodeDialog;
